import gql from "graphql-tag";

// fragment
export const PLANT_FRAGMENT = gql`
    fragment plant on PlantNode {
        id
        name
        plantSpecies {
            id
            name
        }
        defaultSupplier {
            id
            name
        }
        plantColorSet {
            edges {
                node {
                    id
                    color {
                        id
                        color
                    }
                }
            }
        }
        plantPotSizeSet {
            edges {
                node {
                    id
                    youngPlantDefaultCost
                    potSize {
                        id
                        potSizeCm
                    }
                    plantFixedCostTemplate {
                        id
                        templateName
                        totalCost
                        failureRate
                        plantFixedCostTemplateItemSet(orderBy: "itemName") {
                            totalCount
                            edges {
                                node {
                                    id
                                    itemName
                                    costValue
                                }
                            }
                        }
                    }
                }
            }
        }
        plantEnvironmentSet {
            edges {
                node {
                    id
                    environment {
                        id
                        environment
                    }
                }
            }
        }
        plantTagSet {
            edges {
                node {
                    id
                    tag {
                        id
                        tag
                        orderId
                    }
                }
            }
        }
        plantGrowthTemplateSet {
            edges {
                node {
                    id
                    name
                    numPhases
                    totalGrowthDays
                    maxSalesDays
                    seasonEffectMonths
                    totalM2Days
                    potSize {
                        id
                        potSizeCm
                    }
                }
            }
        }
        createdAt
        updatedAt
    }
`;

// all query
export const PLANTS_QUERY = gql`
    query {
        tenantPlants(orderBy: "-updatedAt") {
            edges {
                node {
                    ...plant
                }
            }
        }
    }
    ${PLANT_FRAGMENT}
`;

// single query
export const SINGLE_PLANT_QUERY = gql`
    query plant($id: ID!) {
        plant(id: $id) {
            ...plant
        }
    }
    ${PLANT_FRAGMENT}
`;

// create
export const CREAT_PLANT_MUTATION = gql`
    mutation createPlant($input: CreatePlantInput!) {
        createPlant(input: $input) {
            plant {
                ...plant
            }
        }
    }
    ${PLANT_FRAGMENT}
`;

// update
export const UPDATE_PLANT_MUTATION = gql`
    mutation updatePlant($input: UpdatePlantInput!) {
        updatePlant(input: $input) {
            plant {
                ...plant
            }
        }
    }
    ${PLANT_FRAGMENT}
`;

// delete
export const DELETE_PLANT_MUTATION = gql`
    mutation deletePlant($input: DeletePlantInput!) {
        deletePlant(input: $input) {
            plant {
                ...plant
            }
        }
    }
    ${PLANT_FRAGMENT}
`;
